import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { DadosEmpresaService } from 'src/app/services/dados-empresa.service';
import { CepPlacesService } from '@services/cep-places.service';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { DomUtilsService } from '@utils/DomUtilsService';
import { CustomErrorHandler } from '@utils/custom-error-handler';
import { EnderecoFormBase } from '@pages/utils/endereco-form.base';
import { PageLayoutComponent } from '../../components/page-layout/page-layout.component';
import { EnderecoFormComponent } from '../../components/endereco-form/endereco-form.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-adicionar-endereco',
    templateUrl: './adicionar-endereco.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageLayoutComponent, EnderecoFormComponent, NgClass]
})
export class AdicionarEnderecoComponent extends EnderecoFormBase {

  public idEmpresaLogada = localStorage.idEmpresaLogada;

  constructor(
    formularioBuilder: UntypedFormBuilder,
    cepPlacesService: CepPlacesService,
    private readonly serviceEndereco: DadosEmpresaService,
    public rota: Router,
    private readonly domUtils: DomUtilsService,
  ) {
    super(formularioBuilder, cepPlacesService);
  }

  adicionarEmpresa() {
    if (this.formulario.invalid) {
      return;
    }

    const cepControl = this.formulario.get('codigoCep');
    if (cepControl?.value && !this['cepValido'](cepControl.value)) {
      this.mensagemErro = 'CEP inválido. Informe um CEP válido.';
      return;
    }

    this.alertLoading = true;
    this.serviceEndereco.createNewEndereco(this.idEmpresaLogada, this.buildEnderecoPayload())
      .pipe(take(1)).subscribe({
        next: (response: any) => {
          if (response.status === 'OK') {
            this.alertLoading = false;
            this.alertSucesso = true;
          } else {
            this.alertError = true;
            this.mensagemErro = response.mensagem;
          }
        },
        error: (erro: any) => {
          console.error(erro);
          this.alertLoading = false;
          this.alertError = true;
          this.mensagemErro = CustomErrorHandler.extrairMensagem(erro, 'Erro ao cadastrar endereço.');
        }
      });
  }

  voltarAbaEnderecos() {
    this.rota.navigate(['dados-empresa']);
    this.domUtils.aguardarElementoClique('enderecoTab', 1500, 3);
  }

  fecharAlertSucesso(evento: string) {
    this.alertSucesso = false;
    this.rota.navigate(['dados-empresa']);
    this.domUtils.aguardarElementoClique('enderecoTab', 1200, 4);
  }

  somenteNumeros(e: any) {
    const charCode = e.charCode ?? e.keyCode;
    if (charCode != 8 && charCode != 9) {
      if ((charCode < 48 || charCode > 57) || (e.target.value.length >= 10)) return false;
    }
  }
}
